<template>
    <div class="container py-4 my-24">
        <div class="flex justify-center">
            <div class="max-w-sm mb-8">
                <img
                        src="../assets/images/404.svg"
                        alt=""
                >
            </div>
        </div>
        <div class="text-center text-black">
            <h1 class="font-semibold text-4xl mb-3">Page not found!</h1>
            <p>The page you are looking for doesn't exists.</p>
            <a
                    href="/"
                    class="font-semibold bg-green text-white rounded-full py-2 px-10 mt-6 inline-block no-underline"
            >Go Home
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        metaInfo() {
            return {
                title: "404"
            };
        }
    };
</script>
